import { isDemo } from 'pl-games-kit';

import { DemoService } from './demoService';
import { DataService } from './dataService';

import mainConfig from '../configs/mainConfig';

export default mainConfig.game.demoMode.enable && !mainConfig.game.demoMode.viewOnly && isDemo ? new DemoService() : new DataService();
